const isoDatePrefixPattern = /^(\d{4})-(\d{2})-(\d{2})/u;
const calendarDatePattern = /^(\d{4})-(\d{2})-(\d{2})$/u;

const dateLabelOptions: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
};

/**
 * Parses a date for display in the viewer's own calendar. A bare `YYYY-MM-DD`
 * (a URL slug) is a calendar date and maps to local midnight of that day. A
 * full timestamp is an instant and lands on whatever day it is in the browser
 * time zone (MEN-5433).
 */
export const parseDisplayDate = (value: string): Date | null => {
  const match = value.match(calendarDatePattern);
  const date = match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const toDateSlug = (
  value: string | null | undefined,
  fallbackSlug: string,
): string => {
  const trimmedValue = value?.trim();
  if (!trimmedValue) {
    return fallbackSlug;
  }

  const datePrefix = trimmedValue.match(isoDatePrefixPattern)?.[0];
  if (datePrefix) {
    return datePrefix;
  }

  const date = new Date(trimmedValue);
  if (Number.isNaN(date.getTime())) {
    return fallbackSlug;
  }
  return date.toISOString().slice(0, 10);
};

export const formatDateLabel = (
  value: string | null | undefined,
  ignoredFallbackSlugs: string[] = [],
): string | undefined => {
  const trimmedValue = value?.trim();
  if (!trimmedValue || ignoredFallbackSlugs.includes(trimmedValue)) {
    return undefined;
  }

  return parseDisplayDate(trimmedValue)?.toLocaleDateString(
    'en-US',
    dateLabelOptions,
  );
};
